import { render, staticRenderFns } from "./ScrBacen.vue?vue&type=template&id=2e677f6e"
import script from "./ScrBacen.vue?vue&type=script&lang=js"
export * from "./ScrBacen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports